import {Component} from '@angular/core';

@Component({
  selector: 'app-contact-admin',
  template: `<router-outlet></router-outlet>`
})
export class ContactSectionComponent {
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/contact.ts